import proj4 from "proj4";

import { DimensionValueSet } from "@/lib/dimensions";
import {
  BaseTileImageLoader,
  GetTileImageProps,
} from "@/lib/map-layers/abstract/base-tiled-layer";
import { getAuthToken } from "@/features/shared/features/authentication";

export class WmsTileImageLoader extends BaseTileImageLoader {
  private dashboardId;
  private mapLayerId;

  constructor(dashboardId: string, mapLayerId: string) {
    super();
    this.dashboardId = dashboardId;
    this.mapLayerId = mapLayerId;
  }

  tileImageRequest(dimensionValues: DimensionValueSet, props: GetTileImageProps) {
    return new Request(this.tileImageUrl(dimensionValues, props), {
      headers: {
        Authorization: `Bearer ${getAuthToken()?.access_token}`,
      },
      signal: props.signal,
    });
  }

  private tileImageUrl(
    dimensionValues: DimensionValueSet,
    { tile }: GetTileImageProps,
  ): string {
    const [east, north] = proj4("EPSG:4326", "EPSG:3857", [
      tile.bbox.east,
      tile.bbox.north,
    ]);
    const [west, south] = proj4("EPSG:4326", "EPSG:3857", [
      tile.bbox.west,
      tile.bbox.south,
    ]);

    const queryString = new URLSearchParams({
      ...this.mapDimensionsToQueryString(dimensionValues),
      crs: "EPSG:3857",
      bbox: `${west},${south},${east},${north}`,
      height: tile.tileSize.toString(),
      width: tile.tileSize.toString(),
    });

    return `${import.meta.env.VITE_API_BASE_PATH}/published/dashboards/${
      this.dashboardId
    }/map_layers/${this.mapLayerId}/wms_tile?${queryString.toString()}`;
  }

  private mapDimensionsToQueryString(dimensionValues: DimensionValueSet) {
    return Object.entries(dimensionValues).reduce<{
      [dimensionId: string]: string;
    }>((acc, [id, value]) => {
      acc[`dimension_${id}`] = value.queryStringValue;
      return acc;
    }, {});
  }
}
